import { Record } from 'immutable';
import { construct, fields, resolveAll } from '../helpers/LinkMapper';
import { SeatingPrefNames } from '../constants/AppConstants';
import { translate as t } from '../lib/I18n';

const ReservationSeat = new Record({
    seat: null,
    attributes: [],
    coach: null,
});

Object.assign(ReservationSeat.prototype, {
    getAttributes() {
        const joined = this.attributes
            .map(pref => SeatingPrefNames[pref])
            .filter(Boolean)
            .map(i18nKey => t(i18nKey))
            .join(', ');
        return joined.charAt(0).toUpperCase() + joined.slice(1).toLowerCase();
    },
});

ReservationSeat.fromJSON = function(json) {
    return construct(ReservationSeat, json, {
        seat: fields.string,
        attributes: resolveAll(json.attributes).with(String),
        coach: fields.string,
    });
};

export default ReservationSeat;
